import React from "react";

// Local Imports
import mermaidWarrior from "../../images/illustration/mermaid-warrior.jpg";

// Font Awesome Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons";

// React PopUpBox
import { PopupboxContainer, PopupboxManager } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";

function Ill_Project_3() {
  // Mermaid Warrior
  const openPopupBoxMermaidWarrior = () => {
    const content = (
      <>
        <img
          className="portfolio-image-popupbox"
          src={mermaidWarrior}
          alt="A digitally made original painting of a mermaid warrior"
        />
        <p>A digitally made original painting of a mermaid warrior</p>
      </>
    );
    PopupboxManager.open({ content });
    PopupboxManager.update({
      content,
      config: {
        titleBar: {
          text: "Mermaid Warrior | Original",
        },
      },
    });
  };

  const popupboxConfigMermaidWarrior = {
    titleBar: {
      enable: true,
      text: "Mermaid Warrior | Original",
    },
    fadeIn: true,
    fadeInSpeed: 500,
  };

  return (
    <>
      <div className="portfolio-image-box" onClick={openPopupBoxMermaidWarrior}>
        <img
          className="portfolio-image constraints image-top-center"
          src={mermaidWarrior}
          alt="Screenshot of Mermaid Warrior"
        />
        <div className="overflow"></div>
        <FontAwesomeIcon className="portfolio-icon" icon={faSearchPlus} />
      </div>
      <PopupboxContainer {...popupboxConfigMermaidWarrior} />
    </>
  );
}

export default Ill_Project_3;
